<div *ngFor="let f of files">
    <div class="file-actions">
        <a download target="_blank" class="file-icons" href="{{ baseFiles}}{{f}}">
            <img src="..\assets\icons\downlod.png" alt="" style="width:14px; height:14px;">
        </a>
    </div>
</div>
